import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { EDIT_SELECTOR } from "../../../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../../../base/base.component";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { Subscription } from "rxjs";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import {
    FORM_TYPE_CHECKBOX, FORM_TYPE_FILE,
    FORM_TYPE_MULTISELECT,
    FORM_TYPE_TEXT,
    FORM_WIDTH_COL_4,
    FORM_WIDTH_OFFSET_COL_0
} from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import {
    PRIVATE_PROMOTION_LIST_ROUTE
} from "../../../../../crossconcern/utilities/properties/routename.property";
import { PhotosphereManager } from "../../../../../business/managers/photosphere.manager";
import { concatMap, finalize, map } from "rxjs/operators";
import { PromotionModel } from "../../../../../datastore/entities/promotion.model";
import { ProductModel } from "../../../../../datastore/entities/product.model";
import { IDropdownSettings } from "ng-multiselect-dropdown/multiselect.model";
import { NurseryModel } from "app/datastore/entities/nursery.model";
import { NurseryManager } from "app/business/managers/nursery.manager";
import { MediaList } from "../../../../../datastore/entities/medialist.model";

@Component({
    selector: EDIT_SELECTOR,
    templateUrl: "./promotionedit.component.html"
})
export class PromotionEditComponent extends BaseComponent implements OnInit, OnDestroy {

    public formInfo: FormInfo;
    @ViewChild("formNursery", null) public formComponent;

    public selectedFiles: FileList[] = [];
    public promotionMediaUrl: unknown;

    private onGoBackCalledSubscription: Subscription;

    private products: ProductModel[];
    private nurseries: NurseryModel[];
    private editedPromo: PromotionModel;

    public selectedItems: ProductModel[];
    public selectedNurseryItems: NurseryModel[];
    public dropdownSettings: IDropdownSettings;

    public titleText = "PROMOTION_EDIT_COMPONENT_LABEL";

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected genericService: GenericService,
        private photosphereManager: PhotosphereManager,
        private nurseryManager: NurseryManager,
        private activeRoute: ActivatedRoute,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
        this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "text",
            enableCheckAll: false,
            allowSearchFilter: true
        };

        const formInfoFields: FormInfoField[] = [
            new FormInfoField(
                FORM_TYPE_TEXT,
                "PROMOTION_EDIT_COMPONENT_NAME",
                "name",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_TEXT,
                "PROMOTION_EDIT_COMPONENT_DESC",
                "desc",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_MULTISELECT,
                "PROMOTION_EDIT_COMPONENT_PRODUCTS",
                "products",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0,
                null,
                null,
                null,
                null,
                this.dropdownSettings),
            new FormInfoField(
                FORM_TYPE_MULTISELECT,
                "PROMOTION_EDIT_COMPONENT_NURSERIES",
                "nurseries",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0,
                null,
                null,
                null,
                null,
                this.dropdownSettings),
            new FormInfoField(
                FORM_TYPE_CHECKBOX,
                "PROMOTION_COMPONENT_FEATURED",
                "featured",
                [],
                null,
                null,
                null,
                true,
                false,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_FILE,
                "PROMOTION_COMPONENT_IMAGE",
                "image",
                [],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0,
                undefined,
                undefined,
                ".jpg,.jpeg,.png",
                true)
        ];

        this.formInfo = new FormInfo(formInfoFields, null);

        this.subscribeGenericServices();
    }

    public ngOnInit(): void {
        this.activeRoute.params.subscribe(
            (params) => {
                if(params.id) {
                    this.getPromotion(params.id);
                }
            }
        );
    }

    public ngOnDestroy() {
        this.unsubscribeServices();
    }

    public getPromotion(uuid: string) {
        this.appComponent.startLoading();
        this.photosphereManager.getProducts()
            .pipe(
                concatMap((products) => {
                    this.products = products;
                    return this.nurseryManager.getNurseries(true, 10000, 0)
                        .pipe(
                            concatMap(([
                                _, nurseries
                            ]) => {
                                this.nurseries = nurseries;
                                return this.photosphereManager.getPromotion(uuid);
                            }),
                            concatMap((promotion) => {
                                this.editedPromo = promotion;
                                return this.photosphereManager.getPromotionMedia(promotion.uuid);
                            }),
                            map((medias: MediaList) => {
                                if(medias.medias && medias.medias.length > 0) {
                                    const mediaURL = medias.medias[0].getMediaURL("view_fhd");
                                    if(mediaURL) {
                                        this.promotionMediaUrl = mediaURL.replace("{?res}", "");
                                    }
                                }
                            })
                        );
                }),
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe(() => {
                if(this.editedPromo && this.editedPromo.products) {
                    const prods: ProductModel[] = [];
                    for(const prod of this.editedPromo.products) {
                        prods.push(prod.product);
                    }
                    this.selectedItems = prods;
                } else {
                    this.selectedItems = [];
                }

                if(this.editedPromo && this.editedPromo.nurseries) {
                    const nurseries: NurseryModel[] = [];
                    for(const nurs of this.editedPromo.nurseries) {
                        nurseries.push(nurs.nursery);
                    }
                    this.selectedNurseryItems = nurseries;
                } else {
                    this.selectedNurseryItems = [];
                }

                const language = this.photosphereManager.getCurrentLanguage();

                const values = {
                    name: this.editedPromo.title,
                    desc: this.editedPromo.description,
                    featured: this.editedPromo.featured,
                    products: this.selectedItems.map((prod) => {
                        return {
                            id: prod.uuid,
                            text: this.getProductName(prod, language) };
                    }),
                    nurseries: this.selectedNurseryItems.map((nursery) => {
                        return {
                            id: nursery.uuid,
                            text: nursery.name
                        };
                    }),
                    image: null
                };
                for (const field of this.formInfo.fields) {
                    field.selectedValue = values[field.formControlName];
                    if(field.formControlName === "products") {
                        field.values = this.products.map((prod) => {
                            return {
                                id: prod.uuid,
                                text: this.getProductName(prod, language)
                            };
                        });
                    } else if (field.formControlName === "nurseries") {
                        field.values = this.nurseries.map((nursery) => {
                            return {
                                id: nursery.uuid,
                                text: nursery.name
                            };
                        });
                    }
                }

                this.formComponent.updateFormValues(this.formInfo);
            });
    }

    public onSavePromotion() {
        this.appComponent.startLoading();

        // Products
        const oldProds = this.editedPromo.products
            ? this.editedPromo.products.map((prod) => prod.product.uuid)
            : [];
        const newProds = this.formComponent.form.value.products.map((prod) => prod.id);
        const addedProds = newProds.filter((prod) => !oldProds.includes(prod));
        const deletedProds = oldProds.filter((prod) => !newProds.includes(prod));

        // Nurseries
        const oldNurseries = this.editedPromo.nurseries
            ? this.editedPromo.nurseries.map((nurs) => nurs.nursery.uuid)
            : [];
        const newNurseries = this.formComponent.form.value.nurseries.map((nursery) => nursery.id);
        const addedNurseries = newNurseries.filter((nursery) => !oldNurseries.includes(nursery));
        const deletedNurseries = oldNurseries.filter((nursery) => !newNurseries.includes(nursery));

        this.photosphereManager.updatePromotion(
            this.editedPromo.uuid,
            {
                title: this.formComponent.form.value.name,
                description: this.formComponent.form.value.desc,
                featured: this.formComponent.form.value.featured
            },
            { products: deletedProds },
            { products: addedProds },
            { nurseries: deletedNurseries },
            { nurseries: addedNurseries },
            this.selectedFiles)
            .pipe(
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe(() => {
                this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
            });
    }

    public onFilesSelected(event) {
        this.selectedFiles = event;

        /* eslint-disable dot-notation */
        const file = this.selectedFiles["image"][0];
        /* eslint-enable dot-notation */
        const reader = new FileReader();
        reader.onload = () => this.promotionMediaUrl = reader.result;

        reader.readAsDataURL(file);
    }

    private subscribeGenericServices() {
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(() => {
            this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
        });
    }

    private unsubscribeServices() {
        if(this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    }
}